'use client';

import { selectCart, selectCheckoutPage } from '@/lib/frontend/store/helpers';
import { useAppSelector } from '@/lib/frontend/store/hooks';
import { createSelector } from '@reduxjs/toolkit';
import Link from 'next/link';
import * as React from 'react';

export const selectState = createSelector(
  [selectCart, selectCheckoutPage],
  (cart, checkoutPage) => {
    return {
      cart: cart.value,
      checkoutComplete: checkoutPage.checkoutComplete,
    };
  },
);

export const HeaderCartLink = () => {
  const { cart, checkoutComplete } = useAppSelector(selectState);
  const productLineItems =
    cart != null &&
    cart.LineItems != null &&
    cart.LineItems.filter((lineItem) => {
      return lineItem.Type === 'product' || lineItem.Type === 'license-upgrade';
    });

  if (!checkoutComplete && productLineItems && productLineItems.length > 0) {
    return (
      <li className="">
        <Link
          className="bg-accent rounded-full py-1 px-3 text-background-color font-bold text-sm hover:no-underline hover:bg-accent/90"
          href="/checkout/"
        >
          Cart
        </Link>
      </li>
    );
  } else {
    return null;
  }
};
